import { render, staticRenderFns } from "./PostPackageSetMailsView.vue?vue&type=template&id=5fae803e&scoped=true"
import script from "./PostPackageSetMailsView.vue?vue&type=script&lang=js"
export * from "./PostPackageSetMailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae803e",
  null
  
)

export default component.exports